import React, { useState } from "react";

const HelpPopup = () => {
    const [isPopupVisible, setPopupVisible] = useState(false);

    const togglePopup = () => {
        setPopupVisible(!isPopupVisible);
    };

    return (
        <div>
            {/* Button */}
            <div className="fixed bottom-0 z-30 right-5 md:right-10">
                <button className="btn-main py-2 px-5" onClick={togglePopup}>
                    <div className="flex gap-4">
                        <div>
                            <p className="text-md font-semibold">CAN WE HELP YOU</p>
                        </div>
                    </div>
                </button>
            </div>

            {/* Popup */}
            {isPopupVisible && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white w-11/12 md:w-8/12 lg:w-4/12 rounded-lg shadow-lg p-6 relative">
                        {/* Close Button */}
                        <button
                            className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                            onClick={togglePopup}
                        >
                            &times;
                        </button>

                        <div className={""}>
                            <div className={"pb-5"}>
                                <h1 className={"text-2xl text-blue-950"}>Hubungi Kami</h1>
                            </div>
                        </div>
                        {/* Popup Content */}
                        <ul className="block  justify-between">
                            {/* WhatsApp Section */}
                            <li className="gap-4 mb-4  w-full ">
                                <div className="w-full">
                                    <div className="w-full mx-auto">
                                        <div className="flex flex-col items-center text-center">
                                            <a
                                                href="https://wa.me/628119001211"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="bg-white border border-gray-100 hover:bg-blue-50 w-full text-indigo-600 p-3 rounded-full"
                                            >
                                                <div className="flex items-center gap-3">
                                                    <div className="h-6 w-6">
                                                        <img
                                                            className="h-full w-full"
                                                            src="/assets/icon/icon-call.svg"
                                                            alt="WhatsApp Icon"
                                                        />
                                                    </div>
                                                    <div>
                                                        <h3 className="font-medium text-md text-gray-600">
                                                            WhatsApp Kami
                                                        </h3>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            {/* Call Section */}
                            <li className="gap-4 mb-4 mx-auto w-full ">
                                <div className="w-full">
                                    <div className="w-full mx-auto">
                                        <div className="flex flex-col items-center text-center">
                                            <a
                                                href="tel:+622159666369"
                                                className="bg-white border border-gray-100 hover:bg-blue-50 w-full text-indigo-600 p-3 rounded-full"
                                            >
                                                <div className="flex items-center gap-3">
                                                    <div className="h-6 w-6">
                                                        <img
                                                            className="h-full w-full"
                                                            src="/assets/icon/icon-call.svg"
                                                            alt="Call Icon"
                                                        />
                                                    </div>
                                                    <div>
                                                        <h3 className="font-medium text-md text-gray-600">
                                                            Telepon Kami
                                                        </h3>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            {/* Email Section */}
                            <li className="gap-4 mb-4 mx-auto w-full">
                                <div className="w-full">
                                    <div className="w-full mx-auto">
                                        <div className="flex flex-col items-center text-center">
                                            <a
                                                href="mailto:info@unitek-indonesia.com"
                                                className="bg-white border border-gray-100 hover:bg-blue-50 w-full text-indigo-600 p-3 rounded-full"
                                            >
                                                <div className="flex items-center gap-3">
                                                    <div className="h-6 w-6">
                                                        <img
                                                            className="h-full w-full"
                                                            src="/assets/icon/icon-mail.svg"
                                                            alt="Email Icon"
                                                        />
                                                    </div>
                                                    <div>
                                                        <h3 className="font-medium text-md text-gray-600">
                                                            Email Kami
                                                        </h3>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HelpPopup;
